import { ControleGabineteDto } from '../../api/dto/ControleGabineteDto';
import { ControleGabinete } from '../../modelo';

export class MapeadorControleGabinete {

    mapearControlesGabinete(kanban: ControleGabineteDto[]) {
        return kanban.map(kanbs => ControleGabinete.criar(kanbs));
    }
}
